import { render, staticRenderFns } from "./favourite-icon.vue?vue&type=template&id=12f4863b&functional=true"
import script from "./favourite-icon.vue?vue&type=script&lang=js"
export * from "./favourite-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports